<template>
  <div class="show__wrapper">
    <!-- poster -->
    <div style="transform: scale(1.12)">
      <div
        class="imageWrapper"
        :style="{
          background: backgroundGradient,
          paddingBottom: `${100 * image.ImgData.ratio}%`,
          marginBottom: '24px',
          borderRadius: '8px',
        }"
      >
        <div
        class="imageWrapper"
        :style="{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `url(${image.Img400})`,
          backgroundSize: 'cover',
          filter: 'blur(10px)',
          transform: 'translate(0, 3%) scale(0.98)'
          // overflow: 'hidden',
        }"
      />
        <img
          v-imageloaded
          class="show__image"
          :src="image.Img400"
          :alt="show.TITLE"
        />
      </div>
      <Movie-ratings
        v-if="show.CLASSIFICATION"
        class="showTitle__ageRating"
        :width="30"
        :icon="show.CLASSIFICATION.toLowerCase().replace(/\+| - pending/gi, '')"
      />
    </div>

    <div class="showTitle">
      <div class="showTitle__header">
        <!-- tv / movie -->
        <h6 v-if="show.TYPE">{{ show.TYPE }}</h6>
        <!-- title -->
        <h3 class="showTitle__title">{{ show.TITLE }}</h3>
      </div>
      <!-- year -->
      <!-- <p>{{ show.year }}</p> -->
      <!-- seasons -->
      <!-- age rating -->
    </div>
    <!-- Foxtel channel -->
    <p>{{ show.CHANNEL }}</p>
    


    <!-- themes -->
    <p>
      <span
        v-for="(theme, i) in themes"
        :key="`${show.TITLE.replace(/\s+/gi, '-')}-${theme}-${i}`"
        :class="{
          theme: true,
          theme__match: votes && votes.find(v => v === theme),
        }"
      >
        <i>{{ theme }}</i>
      </span>
    </p>

    <!-- match score -->

    <!-- write-off -->
    <!-- <p>{{ show.description }}</p> -->
    <p>{{ show.SYNOPSIS }}</p>

    <!-- GoT cast -->
    <p v-if="show['GOT TALENT'].length">
      <b>GoT stars:</b> {{ show['GOT TALENT'] }}
    </p>

  </div>




</template>


<script>
import MovieRatings from '@/components/movie-ratings/movie-ratings.vue'

export default {
  name: 'show-card',
  props: {
    show: {
      type: Object,
      required: true,
    },
    votes: {
      type: Array,
      required: true,
    },
  },
  components: {
    MovieRatings,
  },
  data () {
    return {}
  },
  methods: {

  },
  computed: {
    themes () {
      return this.$root.content.themes
        .filter(t => this.show[t] > 0)
    },
    image () {
      if (this.show && this.show.image && this.$root.content.allImages[this.show.image]) {
        // console.log(this.show.image, this.$root.content.allImages[this.show.image].colors.DarkVibrant)
        return this.$root.content.allImages[this.show.image]
      } else {
        return this.$root.content.allImages['16_9']
      }
    },
    backgroundGradient () {
      const { Vibrant, DarkVibrant, Muted, DarkMuted } = this.image.colors
      const from = Vibrant || Muted
      const to = DarkVibrant || DarkMuted

      return `linear-gradient(to bottom, rgb(${from._rgb.join()}), rgb(${to._rgb.join()}))`
    }
  },

}
</script>


<style scoped lang="sass">
@import index

// $max-width: 400px

.show
  &__wrapper
    // flex: 1 1 0
    // min-width: 200px
    // @media screen and (min-width: 700px)
    //   min-width: 300px
    // width: 30%
    // max-width: $max-width
    margin: 16px
    padding: 0 8px 24px 8px
    border-bottom: solid 1px $color-grey-2
  &__image
    position: absolute
    display: hidden
    top: 0
    left: 0
    width: 100%
    height: auto
    margin: 0
    opacity: 0
    border-radius: 8px
    // margin-bottom: 16px


.theme
  color: $color-grey-5
  // text-transform: uppercase
  &:after
    content: ', '
  &:last-child:after
    content: ''
  &__match
    color: yellowgreen
    font-weight: 800


.showTitle
  display: flex
  flex-wrap: wrap
  &__header
    flex: 1 1 0
  &__ageRating
    position: absolute
    bottom: 0
    right: 0
    flex: 0 0 0
    height: 32px
    margin: 0
    padding: 2px 0 0 2px
    border-radius: 4px 0 0 0
    background: white
  &__title
    margin-bottom: 4px



</style>



// WEBPACK FOOTER //
// src/components/got-show-matcher/show-card.vue